import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useRouteMatch } from 'react-router-dom';

import {  useHistory } from 'react-router-dom';
import 'moment/locale/es';

const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');

//Components
import StyledPageContent from '../components/StyledPage';
import Loading from '../components/Loading';
import FormErrors,{ trowError } from '../components/FormErrors';

import AcreditacionProfile from '../models/AcreditacionProfile';

import { textAreaStyle } from '../styles/includes/forms'


const StyledPage = styled(StyledPageContent)`
  .event-wrapper {
    & > * {
      &:not(:last-child) {
        border-bottom: 1px solid var(--color-gray-light);
      }
    }
  }
  .status-info-wrapper {
    margin-top: 2rem;
  }
`

const Center = styled.p`
  text-align:center;
`;


const StyledForm = styled.form`
  h1 {
    margin-bottom: 2.5rem;
  }
  h2 {
    margin: 1.5rem 0;
  }
  h3 {
    margin: 1.3rem 0;
  }
  textarea {
    ${textAreaStyle}
    width: 100%;
    height: 80px;
    padding: 12px;
  }
  .field {
    margin-bottom: 1rem;
  }
  .page-footer {
    text-align: center;
    margin-top: 2rem
  }
  .sample-photo {
    max-width: 120px;
    margin: auto;
    img {
      box-shadow: var(--base-box-shadow);
      width: 100%;
    }
  }
`;

export default  () => {
    let history = useHistory();
    let UserInfo=AcreditacionProfile.getProfile();

    const { params } = useRouteMatch<{url:string}>();

    const [submitError,setSubmitError] = useState<null|string>(null);
    const [loading,setLoading] = useState(true);
    const [conten,setContent] = useState('');

    useEffect(() => {
        ( async () =>{
            setSubmitError(null);
            setLoading(true);
      
            try{
                let response= await fetch(`https://www.atleticodesanluis.mx/webservices/get_content/${params.url}`);
                let responseJson=await response.json();

                setContent(responseJson.conten);
            }catch(e){
                setSubmitError(e.message);
            }finally{
                setLoading(false);
            }
        })();
    },[]);

    if(loading)
        return <Loading />


    return (
        <StyledPage>
            {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}
            <StyledForm>
                <div dangerouslySetInnerHTML={{ __html: conten}} />
            </StyledForm>
        </StyledPage>
    )
}

